import { formatDateForTimestamp } from "~/scripts/useful-functions"
import type { AxiosInstance } from "axios"
import type { RuntimeConfig } from "#app"

export class TrackingService {
  constructor(
    private axios: AxiosInstance,
    private config: RuntimeConfig
  ) {}

  async postTrackingEvent(event: object, route, cookie, page, window?): Promise<any | null> {
    const trackingServiceUrl = this.config.v4Host + "/api/v3/tracking"

    const defaultEventDetails = {
      url: {
        host: this.config.frontendHost,
        path: route.path
      },
      ...(window ? { user_agent: window.navigator.userAgent } : {}),
      session_id: cookie.value || null,
      timestamp: formatDateForTimestamp()
    }

    let query = route.query || []
    query.landing_path = page.uri
    query.landing_source = "cms"

    try {
      const response = await this.axios.post(
        trackingServiceUrl,
        {
          events: [{ ...defaultEventDetails, ...event }]
        },
        {
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          },
          params: route.query,
          withCredentials: true
        }
      )

      if (response && response.data && response.data.track_id) {
        window.anyvan_track_id = response.data.track_id
      }

      if (response.status === 200) {
        return response
      }
    } catch (err) {
      return null
    }
  }
}
